<template>
  <div id="app">
    <HeaderSection />
    <main>
      <HeroSection />
      <CategoriesSection />
      <FeaturedProducts />
      <DealsSection />
      <TestimonialsSection />
      <FeaturesSection />
      <NewsletterSection />
    </main>
    <FooterSection />
  </div>
</template>

<script>
import HeaderSection from '../components/home/HeaderComponent.vue'
import HeroSection from '../components/home/HeroSectionComponent.vue'
import CategoriesSection from '../components/home/CategoriesSectionComponent.vue'
import FeaturedProducts from '../components/home/FeaturedProductsComponent.vue'
import DealsSection from '../components/home/DealsSectionComponent.vue'
import TestimonialsSection from '../components/home/TestimonialsSectionComponent.vue'
import FeaturesSection from '../components/home/FeaturesSectionComponent.vue'
import NewsletterSection from '../components/home/NewsletterSectionComponent.vue'
import FooterSection from '../components/home/FooterComponent.vue'

export default {
  name: 'App',
  components: {
    HeaderSection,
    HeroSection,
    CategoriesSection,
    FeaturedProducts,
    DealsSection,
    TestimonialsSection,
    FeaturesSection,
    NewsletterSection,
    FooterSection
  },
  methods: {
    startWarning() {
      this.$swal.fire({
        title: "<strong> <i class='fas fa-file-invoice' style='color: green;'></i> Release Note</strong>",
        confirmButtonColor: '#00cc66',
        icon: 'warning',
        html: "Dear User, the web is not completed! Please help with development. Press the purple button to send new items and report issues via WhatsApp. All texts are encoded in Base64 before sending. <br/> මෙම වෙබ් එක සම්පූර්න කර නොමැත. තවමත් නිර්මාණ කටයුතු කරගන යන අතර ඒ සදහා ඔබගේ සහය බලාපොරොත්තු වෙමි. කරුනාකර මෙම වෙබ් එක භාවිතාකර මෙහි අඩුපාඩු සහ වෙනස් කල යුතු දෙවල් පිලිබද හෝ එකතුකල යුතු නව උපාංග සදහා පහල ඇති දම් පාට බොත්තම ඔබා අදාල ඇක්ශන් බටන මගින් ලැබෙන පැනලයන් හරහා අදාල විස්තර ඇතුලත් කර සබ්මිට් කරන්න. ඒවා ඔබගේ වට්සැප් ගිනුම හරහා මැසේජයක් ආකාරයෙන් මට ලැබෙන අතර අදාල පනිවිඩය බේස්64 ආකාරයට එන්ක්‍රිප්ට් වී ඇත. <br/> Thanks for supporting us! "
      });
    }
  },
  mounted() {
    // this.startWarning(); // Automatically trigger the popup when the page loads
  }


}
</script>

<style>
/* Global styles from styles.css */
:root {
  --primary-color: #2e7d32;
  --primary-light: #60ad5e;
  --primary-dark: #005005;
  --secondary-color: #1b5e20;
  --accent-color: #4caf50;
  --text-color: #212121;
  --text-light: #757575;
  --background-color: #f5f5f5;
  --white: #ffffff;
  --gray-light: #eeeeee;
  --gray: #9e9e9e;
  --black: #000000;
  --success: #4caf50;
  --warning: #ff9800;
  --error: #f44336;
  --border-radius: 4px;
  --box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  --transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--text-color);
  background-color: var(--background-color);
  line-height: 1.6;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

button {
  cursor: pointer;
  font-family: inherit;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.section-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
  color: var(--primary-dark);
}

.btn-primary {
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--white);
  padding: 12px 30px;
  border-radius: var(--border-radius);
  font-weight: 600;
  transition: var(--transition);
  border: none;
}

.btn-primary:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
}

.btn-secondary {
  display: inline-block;
  background-color: transparent;
  color: var(--primary-color);
  padding: 10px 25px;
  border-radius: var(--border-radius);
  font-weight: 600;
  transition: var(--transition);
  border: 2px solid var(--primary-color);
}

.btn-secondary:hover {
  background-color: var(--primary-color);
  color: var(--white);
}

/* Responsive styles */
@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
  }
}
</style>